getLanguageFromMixedType